<!-- 数据需求方详情 -->
<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      :width="dialogWidth"
      :before-close="closeDialog"
    >
    <div class="content-content" v-loading="loading">
      <div class="search-content">
        <el-form
          :model="companyForm"
          label-width="130px"
          ref="companyFormRef"
        >
          <div>
            <TitleTool title="数据需求信息"/>
            <div class="pr10 pl10">
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="入驻名称:"
                    label-width="150px"
                    prop="companyName"
                  >
                    <span>
                      {{ companyForm.companyName }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="+dataType === 1 ? '数据需求量:' : '数量说明:'"
                    label-width="150px"
                    prop="dataRequirement"
                  >
                    <span>
                      {{ companyForm.dataRequirement }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="地点:"
                    label-width="150px"
                  >
                    <span>
                      {{ companyForm.address }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="需求行业:"
                    label-width="150px"
                  >
                    <span>
                      {{ transFormEnum(labelList, companyForm.businessType) }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item
                    :label="+dataType === 1 ? '数据需求描述:' : '数据服务内容:'"
                    label-width="150px"
                  >
                    <span>
                      {{ companyForm.requireMent }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
        <el-form
          :model="ruleForm"
          label-width="130px"
          ref="ruleForm"
        >
          <div>
            <TitleTool title="企业基本信息"/>
            <div class="pr10 pl10">
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="企业全称:"
                    prop="enterpriseName"
                  >
                    <span>
                      <EnterpriseLink :id="enterpriseId || (ruleForm && ruleForm.id)" :name="ruleForm.enterpriseName" />
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="公司产品:"
                    prop="companyProduct"
                  >
                  <span>
                    {{ transFormEnum(companyProductList, ruleForm.companyProduct, true) }}
                  </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="企业简称:"
                    prop="enterpriseAbbreviation"
                  >
                    <span>
                      {{ ruleForm.enterpriseAbbreviation }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="DCMM等级:"
                    prop="dcmmRating"
                  >
                    <span>
                      {{ transFormEnum(DCMNSelectList, ruleForm.dcmmRating) }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="成立日期:"
                    prop="dateOfEstablishment"
                  >
                    <span>
                      {{ ruleForm.dateOfEstablishment }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="人员规模:"
                    prop="personnelSize"
                  >
                    <span>
                      {{ ruleForm.personnelSize }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="注册资本:"
                    prop="registeredCapital"
                  >
                    <span>
                      {{ ruleForm.registeredCapital }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="办公地址:"
                    prop="officeAddress"
                  >
                    <span>
                      {{ ruleForm.officeAddress }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="企业类型:"
                    prop="typeOfEnterprise"
                  >
                    <span>
                      {{ transFormEnum(typeOfEnterpriseEnum, ruleForm.typeOfEnterprise) }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="电话:"
                    prop="phone"
                  >
                    {{ ruleForm.phone }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="企业官网地址:"
                    prop="url"
                  >
                    <span>
                      {{ ruleForm.url }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="邮箱:"
                    prop="email"
                  >
                    <span>
                      {{ ruleForm.email }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="行政区划:"
                    prop="administrativeDivision"
                  >
                    {{ ruleForm.administrativeDivisionName }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="公司介绍:"
                    prop="companyProfile"
                  >
                    <span>
                      {{ ruleForm.companyProfile }}
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="ent-jump">
            <button type="button" class="ent-jump-btn" @click="goEnterprise">查看所属企业</button>
          </div>
        </el-form>
      </div>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { enterpriseInfoDetail, getListingDetail } from '@/api/Home';
import { getDataType, regionList } from '@/api/Layout/index.js'
import {enumType} from '@/utils/enum.js'
import { P } from '@/router/paths'
import EnterpriseLink from '@/components/EnterpriseLink/index.vue'
export default {
  name: 'DataDemandSide',
  components: { EnterpriseLink },
  props: {
    // 数据类型
    dataType:{
      type: String,
      default: '1'
    },
    showDialog:{
      type: Boolean,
      default: false
    },
    enterpriseId: {
      type: String,
      default: ''
    },
    companyId: {
      type: String,
      default: ''
    },
    dialogTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      input2: '',
      option: [],
      labelList: [],
      DCMNSelectList: [],
      areaList: [],
      companyProductList:[],
      typeOfEnterpriseEnum: [],
      industryEnum: [],
      dataAgingEnum: [],
      administrativeDivisionList:[],
      companyForm: {},
      ruleForm: {},
      dialogVisible: false,
      dialogImageUrl: '',
      dialogVisible1: false,
      loading: false,
      prodUrl:"https://shujuzichan.com/xwzx"
    }
  },
  computed: {
    dialogWidth() {
      return typeof window !== 'undefined' && window.innerWidth < 960 ? '94%' : '80%'
    },
    pictureList() {
      return function (picValue) {
        if(picValue) {
          return picValue.split(',').map(item => item.trim())
        } else {
          return ''
        }
      }
    },
    transFormEnum () {
      return function (enumList, value, multi) {
        if(value) {
          let valObj = []
          if(multi) {
            valObj = JSON.parse(value)
          } else {
            valObj = value.split(',').map(item => item.trim())
          }
          let labelListEnum = []
          if(enumList && enumList.length > 0) {
            enumList.forEach(item => {
              valObj && valObj.forEach(itemObj => {
                if(itemObj === item.value) {
                  labelListEnum.push(item.label)
                }
              })
            })
          }
          return labelListEnum.join(',')
        } else {
          return ''
        }
      }
    }
  },
  watch:{
    'showDialog': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val && this.enterpriseId && this.companyId) {
          this.dialogVisible = val
          this.init()
        }
      }
    }
  },
  created() {
  },
  methods: {
     // 地区
     regionArea() {
      regionList().then(resArea => {
        if(resArea && resArea.data && resArea.data.length > 0) {
          this.areaList = resArea.data
        } else {
          this.areaList = []
        }
      }).catch(()=>{})
    },
    // 枚举
    async getData(type) {
      try {
        const res = await getDataType(type);
        if (res && res.data && res.data.length > 0) {
          if(type === 'sys_business_type') {
            this.labelList = enumType(res.data)
          }
          if(type === 'sys_yes_no') {
            this.option = enumType(res.data)
          }
          if(type === 'sys_enterprise_dcmm_rating') {
            this.DCMNSelectList = enumType(res.data)
          }
          if(type === 'sys_enterprise_type') {
            this.typeOfEnterpriseEnum = enumType(res.data)
          }
          if(type === 'sys_data_aging') {
            this.dataAgingEnum = enumType(res.data)
          }
          if(type === 'sys_company_product') {
            this.companyProductList = enumType(res.data)
          }
          if(type === 'sys_product_service_industry_type') {
            this.industryEnum = enumType(res.data)
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    },
    init() {
      this.getData('sys_enterprise_type')
      this.getData('sys_data_aging')
      this.getData('sys_business_type')
      this.getData('sys_enterprise_dcmm_rating')
      this.getData('sys_yes_no')
      this.getData('sys_company_product')
      this.getData('sys_product_service_industry_type')
      this.regionArea()
      this.loading = true
      enterpriseInfoDetail(this.enterpriseId).then(res=>{
        // this.loading = false
        this.ruleForm = res.data
        getListingDetail(this.companyId).then(res=>{
          this.loading = false
          this.companyForm = res.data
        }).catch(()=>{
          this.loading = false
        })
      }).catch(()=>{
        this.loading = false
      })
    },
    goEnterprise() {
      const id = this.enterpriseId || (this.ruleForm && this.ruleForm.id)
      if (!id) return
      this.closeDialog()
      this.$router.push(P.enterprise(id))
    },
    closeDialog() {
      this.dialogVisible = false
      this.$emit('closeDetailDialog', false)
    }
  }
}
</script>
<style lang="css" scoped>
.ent-jump {
  padding: 8px 10px 0;
}
.ent-jump-btn {
  height: 36px;
  padding: 0 14px;
  border: 1px solid #0165FF;
  border-radius: 8px;
  background: #fff;
  color: #0165FF;
  cursor: pointer;
  font-family: inherit;
}
@media (max-width: 960px) {
  .content-content :deep(.el-col) {
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
  .content-content :deep(.el-form-item) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 10px;
  }
  .content-content :deep(.el-form-item__label) {
    width: auto !important;
    text-align: left !important;
    line-height: 1.35 !important;
    height: auto !important;
    padding: 0 0 2px !important;
    font-size: 12px !important;
  }
  .content-content :deep(.el-form-item__content) {
    margin-left: 0 !important;
    font-size: 13px !important;
  }
  .ent-jump-btn {
    width: 100%;
    height: 34px;
    font-size: 13px;
  }
}
</style>